 /* ==========================================
   DEFAULT PRODUCT GRID - CUSTOM QUICK ADD
========================================== */
(() => {
    if (window.__GRID_QUICKADD_INIT__) return;
  window.__GRID_QUICKADD_INIT__ = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function money(cents) {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const currency = window.Shopify?.currency?.active || 'USD';

    if (currency === 'AUD' || currency === 'USD') return '$' + amount;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    } catch (e) {
      return amount;
    }
  }

  onReady(() => {
    const modal = document.querySelector('[data-grid-modal]');
    if (!modal) return;

    const elImg = modal.querySelector('[data-grid-img]');
    const elTitleLink = modal.querySelector('[data-grid-titlelink]');
    const elPrice = modal.querySelector('[data-grid-price]');
    const elQty = modal.querySelector('[data-grid-qty]');
    const elCTA = modal.querySelector('[data-grid-cta]');
    const elCheckout = modal.querySelector('[data-grid-checkout]');
    const elSoldout = modal.querySelector('[data-grid-soldout]');
    const elMsg = modal.querySelector('[data-grid-msg]');
    const elFitWrap = modal.querySelector('[data-grid-fit]');
    const elFitBtnsWrap = modal.querySelector('[data-grid-fit-buttons]');
    const elFitHint = modal.querySelector('[data-grid-fit-hint]');

    let currentProduct = null;
    let selectedVariant = null;
    let fitOptionIndex = -1;

    function resetModal() {
      currentProduct = null;
      selectedVariant = null;
      fitOptionIndex = -1;

      modal.hidden = true;
      document.documentElement.classList.remove('grid-quickadd-open');
      document.body.classList.remove('grid-quickadd-open');

      if (elQty) elQty.value = 1;
      if (elMsg) {
        elMsg.hidden = true;
        elMsg.textContent = '';
      }
      if (elSoldout) elSoldout.hidden = true;
      if (elFitWrap) elFitWrap.hidden = true;
      if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';
      if (elFitHint) elFitHint.hidden = true;

      if (elCTA) {
        elCTA.disabled = true;
        elCTA.textContent = 'ADD TO BAG';
        elCTA.removeAttribute('aria-busy');
      }

      if (elCheckout) {
        elCheckout.disabled = true;
        elCheckout.textContent = 'PROCEED TO CHECKOUT';
        elCheckout.removeAttribute('aria-busy');
      }
    }

    function openModal() {
      modal.hidden = false;
      document.documentElement.classList.add('grid-quickadd-open');
      document.body.classList.add('grid-quickadd-open');
    }

    function closeModal() {
      resetModal();
    }

    function detectFitOptionIndex(product) {
      if (!product || !product.options || !product.options.length) return -1;

      const byName = product.options.findIndex((opt) =>
        String(opt || '').toLowerCase().includes('fit')
      );
      if (byName !== -1) return byName;

      const commonFitValues = ['standard', 'slimline', 'slim', 'regular', 'classic'];
      const variants = product.variants || [];

      for (let i = 0; i < 3; i++) {
        const hasFitLike = variants.some((variant) => {
          const value = variant?.options ? variant.options[i] : '';
          return commonFitValues.includes(String(value || '').toLowerCase());
        });
        if (hasFitLike) return i;
      }

      return -1;
    }

function setButtonsState() {
  const canProceed = !!(
    selectedVariant &&
    selectedVariant.id &&
    selectedVariant.available
  );

  if (elCTA) elCTA.disabled = !canProceed;
  if (elCheckout) elCheckout.disabled = !canProceed;

  if (elSoldout) {
    elSoldout.hidden = canProceed;
  }
}

    function setPrice() {
      if (!elPrice) return;
      elPrice.textContent = selectedVariant ? money(selectedVariant.price) : '';
    }

    function activateFitButton(value) {
      if (!elFitBtnsWrap) return;

      elFitBtnsWrap.querySelectorAll('.grid-fit-btn').forEach((btn) => {
        btn.classList.toggle('is-active', String(btn.getAttribute('data-fit')) === String(value));
      });
    }

    function buildFitButtons(product) {
      if (!elFitWrap || !elFitBtnsWrap) return;

      fitOptionIndex = detectFitOptionIndex(product);

      if (fitOptionIndex === -1) {
        elFitWrap.hidden = true;
        elFitBtnsWrap.innerHTML = '';
        return;
      }

      elFitWrap.hidden = false;

      const seen = new Set();
      const values = [];

      (product.variants || []).forEach((variant) => {
        const value = variant?.options ? variant.options[fitOptionIndex] : '';
        if (value && !seen.has(value)) {
          seen.add(value);
          values.push(value);
        }
      });

      elFitBtnsWrap.innerHTML = values.map((value) => {
        const safeValue = String(value).replace(/"/g, '&quot;');

        const available = (product.variants || []).some((variant) => {
          const optionVal = variant?.options ? variant.options[fitOptionIndex] : '';
          return String(optionVal) === String(value) && variant.available;
        });

        return `
          <button
            type="button"
            class="grid-fit-btn${available ? '' : ' is-disabled'}"
            data-fit="${safeValue}"
            ${available ? '' : 'disabled'}
          >
            ${value}
          </button>
        `;
      }).join('');
    }

   function autoSelectVariant(product) {
  const firstAvailable = (product.variants || []).find((variant) => variant.available) || null;

  selectedVariant = firstAvailable;

  if (!selectedVariant) {
    if (elSoldout) elSoldout.hidden = false;
    if (elCTA) elCTA.disabled = true;
    if (elCheckout) elCheckout.disabled = true;
    return;
  }

  if (fitOptionIndex !== -1 && selectedVariant.options) {
    activateFitButton(selectedVariant.options[fitOptionIndex]);
  }

  setPrice();
  setButtonsState();
}

    async function loadProduct(handle, productUrl) {
      if (elMsg) {
        elMsg.hidden = true;
        elMsg.textContent = '';
      }

      if (elSoldout) elSoldout.hidden = true;
      if (elFitWrap) elFitWrap.hidden = true;
      if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';
      if (elFitHint) elFitHint.hidden = true;

      if (elCTA) elCTA.disabled = true;
      if (elCheckout) elCheckout.disabled = true;

      const response = await fetch(`/products/${handle}.js`, {
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Failed to load product.');

      currentProduct = await response.json();
      selectedVariant = null;
      fitOptionIndex = -1;

      if (elImg) {
        elImg.src = currentProduct.featured_image || '';
        elImg.alt = currentProduct.title || '';
      }

      if (elTitleLink) {
        elTitleLink.textContent = currentProduct.title || '';
        elTitleLink.href = productUrl || `/products/${currentProduct.handle}`;
      }

      buildFitButtons(currentProduct);
      autoSelectVariant(currentProduct);
    }

let isAddingToCart = false;

async function addVariant(nextUrl, triggerBtn, loadingText, fallbackError) {
  if (isAddingToCart) return;
  if (!selectedVariant || !selectedVariant.id || !selectedVariant.available || triggerBtn.disabled) return;

const qty = Math.max(1, parseInt(elQty?.value || '1', 10) || 1);
  const oldText = triggerBtn.textContent;
  isAddingToCart = true;

  triggerBtn.disabled = true;
  triggerBtn.textContent = loadingText;
  triggerBtn.setAttribute('aria-busy', 'true');

  if (elCheckout) {
    elCheckout.disabled = true;
  }

  if (elMsg) {
    elMsg.hidden = true;
    elMsg.textContent = '';
  }

  try {
    const body = new URLSearchParams();
    body.append('id', String(selectedVariant.id));
    body.append('quantity', String(qty));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: body.toString()
    });

    const text = await response.text();
    let data = {};

    try {
      data = JSON.parse(text);
    } catch (e) {}

    if (!response.ok) {
      throw new Error((data && (data.description || data.message)) || fallbackError);
    }

    window.location.href = nextUrl;
  } catch (error) {
    triggerBtn.textContent = oldText;
    triggerBtn.disabled = false;
    triggerBtn.removeAttribute('aria-busy');

    if (elCheckout) {
      elCheckout.disabled = false;
    }

    if (elMsg) {
      elMsg.hidden = false;
      elMsg.textContent = error?.message || fallbackError;
    }

    isAddingToCart = false;
    setButtonsState();
  }
}

    document.addEventListener('click', async (e) => {
      const openBtn = e.target.closest('[data-grid-quickadd]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();

        const handle = openBtn.getAttribute('data-product-handle');
        const productUrl = openBtn.getAttribute('data-product-url');

        openModal();

        try {
          await loadProduct(handle, productUrl);
        } catch (error) {
          if (elMsg) {
            elMsg.hidden = false;
            elMsg.textContent = error?.message || 'Unable to load product.';
          }
        }

        return;
      }

      if (e.target.closest('[data-grid-close]')) {
        closeModal();
        return;
      }

      const minus = e.target.closest('[data-grid-qty-minus]');
      const plus = e.target.closest('[data-grid-qty-plus]');

      if (minus || plus) {
        const current = parseInt(elQty?.value || '1', 10) || 1;
        elQty.value = plus ? current + 1 : Math.max(1, current - 1);
        return;
      }

      const fitBtn = e.target.closest('.grid-fit-btn');
      if (fitBtn && !fitBtn.disabled && currentProduct && fitOptionIndex !== -1) {
        const fitValue = fitBtn.getAttribute('data-fit');

        selectedVariant = (currentProduct.variants || []).find((variant) => {
          const optionVal = variant?.options ? variant.options[fitOptionIndex] : '';
          return String(optionVal) === String(fitValue) && variant.available;
        }) || null;

        activateFitButton(fitValue);
        setPrice();
        setButtonsState();

        if (!selectedVariant && elFitHint) {
          elFitHint.hidden = false;
        } else if (elFitHint) {
          elFitHint.hidden = true;
        }

        return;
      }
    });

    if (elCTA) {
      elCTA.addEventListener('click', () => {
        addVariant('/cart', elCTA, 'ADDING...', 'Could not add to bag. Please try again.');
      });
    }

    if (elCheckout) {
      elCheckout.addEventListener('click', () => {
        addVariant('/checkout', elCheckout, 'PROCESSING...', 'Could not proceed to checkout. Please try again.');
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    resetModal();
  });
})();